module.exports = __webpack_public_path__ + "static/media/vert.6827b2e5.png";